import type { CheckboxProps } from './Checkbox.types'
import * as RadixCheckbox from '@radix-ui/react-checkbox'
import cn from 'classnames'
import * as React from 'react'
import { Icon } from '../icon'
import styles from './Checkbox.module.css'

export function Checkbox({ className, checked, defaultChecked, onCheckedChange, error, ...rest }: CheckboxProps) {
  return (
    <RadixCheckbox.Root
      className={cn(styles.checkbox, className, error && styles.error)}
      checked={checked}
      defaultChecked={defaultChecked}
      onCheckedChange={onCheckedChange}
      {...rest}
    >
      <RadixCheckbox.Indicator asChild>
        <div className={styles.indicator}>
          <Icon glyph="MinusExtraSmall" size={24} className={styles.iconIndeterminate} />
          <Icon glyph="CheckMarkExtraSmall" size={24} className={styles.iconCheck} />
        </div>
      </RadixCheckbox.Indicator>
    </RadixCheckbox.Root>
  )
}

export default Checkbox
